import { z } from 'zod';
import { MEMBER_TAG_COLORS } from '@bulk/types';
import { idSchema, patchOf } from './common';

export const memberTagColorSchema = z.enum(MEMBER_TAG_COLORS);

export const createMemberTagSchema = z.object({
  name: z.string().trim().min(1).max(40),
  color: memberTagColorSchema.default('gray'),
  description: z.string().trim().max(200).nullable().optional(),
});
export type CreateMemberTagInput = z.infer<typeof createMemberTagSchema>;

export const updateMemberTagSchema = patchOf(createMemberTagSchema);
export type UpdateMemberTagInput = z.infer<typeof updateMemberTagSchema>;

export const memberTagRefSchema = z.object({
  id: idSchema,
  name: z.string(),
  color: memberTagColorSchema,
});
export type MemberTagRef = z.infer<typeof memberTagRefSchema>;

export const memberTagSchema = memberTagRefSchema.extend({
  description: z.string().nullable(),
  memberCount: z.number().int().describe('Members carrying the tag, deleted members left out'),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type MemberTagDto = z.infer<typeof memberTagSchema>;

export const MEMBER_BULK_TAG_LIMIT = 200;

export const bulkMemberTagsSchema = z.object({
  memberIds: z.array(idSchema).min(1).max(MEMBER_BULK_TAG_LIMIT),
  tagIds: z.array(idSchema).min(1).max(20),
  action: z.enum(['ADD', 'REMOVE']),
});
export type BulkMemberTagsInput = z.infer<typeof bulkMemberTagsSchema>;

export const bulkMemberTagsResultSchema = z.object({
  changed: z.number().int().describe('Tags given or taken away; one already there, or already gone, is not counted'),
  members: z.number().int().describe('Members whose tags changed'),
});
export type BulkMemberTagsResultDto = z.infer<typeof bulkMemberTagsResultSchema>;
